type Column = {
  name: string;
  uid: string;
  sortable: boolean;
  description?: string;
};

export const columns: Column[] = [
  {
    name: "Birth Registered ID",
    uid: "gn",
    sortable: false,
    description: "National Center for Research in Animal Sciences identifier",
  },
  {
    name: "Name",
    uid: "name",
    sortable: false,
    description: "Profile of The Animal",
  },
  {
    name: "Sex",
    uid: "sex",
    sortable: true,
    description: "Sex of the animal (Male/Female)",
  },
  {
    name: "Birth Date",
    uid: "birthDate",
    sortable: true,
    description: "Sex of the animal (Male/Female)",
  },
  {
    name: "Animal Status",
    uid: "animalStatus",
    sortable: true,
    description: "Current status of the animal ",
  },
  {
    name: "Completed Phase",
    uid: "phases",
    sortable: true,
    description: "Growth phases of the animal (e.g. weaning, breeding, etc.)",
  },
  {
    name: "Pending Phase",
    uid: "addPhase",
    sortable: true,
    description: "Growth phases of the animal (e.g. weaning, breeding, etc.)",
  },
  {
    name: "Address",
    uid: "country",
    sortable: true,
    description: "Country of origin for the animal",
  },
  {
    name: "damName",
    uid: "damName",
    sortable: true,
    description: "Name of the dam.",
  },
  {
    name: "damDGR",
    uid: "damDGR",
    sortable: true,
    description: "Details about the dam's DGR.",
  },
  {
    name: "damBreed",
    uid: "damBreed",
    sortable: true,
    description: "Breed of the dam.",
  },
  {
    name: "Sire DGR",
    uid: "sireDGR",
    sortable: true,
    description: "Details about the sire's DGR.",
  },
  {
    name: "Sire Name",
    uid: "sireName",
    sortable: true,
    description: "Name of the sire.",
  },
  {
    name: "Sire Breed",
    uid: "sireBreed",
    sortable: true,
    description: "Breed of the sire.",
  },
  {
    name: "Paternal GrandDam DGR",
    uid: "paternalGrandDamDGR",
    sortable: true,
    description: "Details about the paternal grand dam's DGR.",
  },
  {
    name: "paternal GrandDam Name",
    uid: "paternalGrandDamName",
    sortable: true,
    description: "Name of the paternal grand dam.",
  },
  {
    name: "paternal GrandDam Breed",
    uid: "paternalGrandDamBreed",
    sortable: true,
    description: "Breed of the paternal grand dam.",
  },
  {
    name: "Paternal GrandSire DGR",
    uid: "paternalGrandSireDGR",
    sortable: true,
    description: "Details about the paternal grand sire's DGR.",
  },
  {
    name: "Paternal GrandSire Name",
    uid: "paternalGrandSireName",
    sortable: true,
    description: "Name of the paternal grand sire.",
  },
  {
    name: "Paternal GrandSire Breed",
    uid: "paternalGrandSireBreed",
    sortable: true,
    description: "Breed of the paternal grand sire.",
  },
  {
    name: "Maternal GrandDam DGR",
    uid: "maternalGrandDamDGR",
    sortable: true,
    description: "Details about the maternal grand dam's DGR.",
  },
  {
    name: "Maternal GrandDam Name",
    uid: "maternalGrandDamName",
    sortable: true,
    description: "Name of the maternal grand dam.",
  },
  {
    name: "Maternal GrandDam Breed",
    uid: "maternalGrandDamBreed",
    sortable: true,
    description: "Breed of the maternal grand dam.",
  },
  {
    name: "Maternal GrandSire DGR",
    uid: "maternalGrandSireDGR",
    sortable: true,
    description: "Details about the maternal grand sire's DGR.",
  },
  {
    name: "Maternal GrandSire Name",
    uid: "maternalGrandSireName",
    sortable: true,
    description: "Name of the maternal grand sire.",
  },
  {
    name: "Maternal GrandSire Breed",
    uid: "maternalGrandSireBreed",
    sortable: true,
    description: "Breed of the maternal grand sire.",
  },
  {
    name: "Farm",
    uid: "farmer",
    sortable: true,
    description: "Name of the farm or breeder",
  },
  {
    name: "Breeding Type",
    uid: "breedingType",
    sortable: true,
    description: "Type of breeding program ",
  },
  {
    name: "Vaccination",
    uid: "vaccination",
    sortable: false,
    description: "Vaccination status of the animal",
  },
  {
    name: "Coat Color",
    uid: "coatColor",
    sortable: true,
    description: "Color of the animal's coat",
  },
  {
    name: "Size",
    uid: "size",
    sortable: true,
    description: "Size of the animal",
  },
  {
    name: "Paternal Nucleus",
    uid: "paternalNucleus",
    sortable: true,
    description: "Genetic material inherited from the father",
  },
  {
    name: "Breed Composition",
    uid: "racialComposition",
    sortable: true,
    description: "Percentage of different breeds in the animal's ancestry",
  },
  {
    name: "ADG",
    uid: "adg",
    sortable: true,
    description: "average daily weight gain ",
  },
  {
    name: "W120",
    uid: "w120",
    sortable: true,
    description: "Current weight of the animal",
  },
  {
    name: "WW",
    uid: "ww",
    sortable: true,
    description: "Current weight of the animal",
  },
  {
    name: "YW",
    uid: "yw",
    sortable: true,
    description: "Current weight of the animal",
  },
  {
    name: "PMWG",
    uid: "pmwg",
    sortable: true,
    description: "Current weight of the animal",
  },
  {
    name: "Weight",
    uid: "weight",
    sortable: true,
    description: "Current weight of the animal",
  },
  {
    name: "Birth Weight",
    uid: "birthWeight",
    sortable: true,
    description: "Birth weight of the animal",
  },
  {
    name: "Assigned Supervisor",
    uid: "assignedSupervisor",
    sortable: true,
    description: "Current weight of the animal",
  },
  {
    name: "Farm ID",
    uid: "farmID",
    sortable: false,
  },
  {
    name: "Actions",
    uid: "actions",
    sortable: false,
  },
];

type VaccinationStatusOption = {
  name: string;
  uid: string;
};

export const vaccinationStatusOptions: VaccinationStatusOption[] = [
  { name: "Vaccinated", uid: "vaccinated" },
  { name: "Not Vaccinated", uid: "not-vaccinated" },
  { name: "Vaccination Pending", uid: "pending" },
];

export const INITIAL_VISIBLE_COLUMNS: string[] = [
  "gn",
  "farmer",
  "name",
  "action",
  "sex",
  "country",
  "breedingType",
  "birthDate",
  "adg",
  "w120",
  "ww",
  "yw",
  "pwmg",
  "motherDGR",
  "motherName",
  "addPhase",
  "vaccination",
  "coatColor",
  "size",
  "paternalNucleus",
  "racialComposition",
  "damName",
  "damDGR",
  "damBreed",
  "sireDGR",
  "sireName",
  "sireBreed",
  "paternalGrandDamDGR",
  "paternalGrandDamName",
  "paternalGrandDamBreed",
  "paternalGrandSireDGR",
  "paternalGrandSireName",
  "paternalGrandSireBreed",
  "maternalGrandDamDGR",
  "maternalGrandDamName",
  "maternalGrandDamBreed",
  "maternalGrandSireDGR",
  "maternalGrandSireName",
  "maternalGrandSireBreed",
  "weight",
  "birthWeight",
  "phases",
  "assignedSupervisor",
  "createdAt",
  "farmID",
  "actions",
];

export interface RecipientInput {
  cowEarTag: string;
  cowManagement: string;
  cowBreed: string;
  syncYear: number;
  syncMonth: string;
  estrousCycle: string;
  bcs: number;
  pregnancyDiagnosis: string;
  finalPregnancyCheck: string;
  observationFinalPregnancyCheck: string;
  calfBirthDate: string;
  calfBirthYear: number;
  calfBirthMonth: string;
  calfNumber: string;
  calfSex: string;
  calfCoatColor: string;
  calfBirthWeight: number;
  calfType: string;
  gestationPeriod: number;
  calfBirthNotes: string;
  calfDeathDate: string | null;
  calfDeathNotes: string | null;
  weaningDate: string;
  weaningWeight: number;
  weaningLocation: string;
  tickCount: number;
  headEvaluation: string;
  bodyType: string;
  color: string;
  muscleDevelopment: string;
  umbilicalCondition: string;
  bodyStructure: string;
  earTagVerified: boolean;
}

export interface ReproductiveProcessData {
  // Cow Information
  cowEarTag: string;
  branding: string;
  cowManagement: string;
  cowBreed: string;
  cowBirthDate: string;

  //donor Animal
  dgrRecipientCow: string;
  donorWeight: number;
  bcsD0: string;
  donorCowAnimal: string;
  donorBreed: string;
  bullName: string;
  dgrBull: string;
  donorBreedSecond: string;
  embryoBreed: string;

  // Synchronization Information
  syncYear: string;
  syncMonth: string;
  dateAIET: string;
  synchRemoval: string;
  syncBatch: string;
  aiOrETType: string;
  bull: string;
  donorCow: string;

  // Pregnancy Information
  pregnancyCheck1: string;
  finalPregnancyCheckDate: string;
  finalPregnancyResult: string;
  finalPregnancyNotes: string;

  // Calf Information
  calfBirthDate: string;
  calfBirthYear: string;
  calfBirthMonth: string;
  calfNumber: string;
  calfSex: string;
  calfCoatColor: string;
  calfBirthWeight: number;
  calfType: string;
  gestationPeriod: number;
  calfBirthNotes: string;
  calfDeathDate: string;
  calfDeathNotes: string;

  // Weaning Information
  weaningDate: string;
  weaningWeight: number;
  weaningLocation: string;

  // Health & Evaluation
  tickCount: number;
  headEvaluation: string;
  bodyType: string;
  color: string;
  muscleDevelopment: string;
  umbilicalCondition: string;
  bodyStructure: string;
  generalConformation: string;
  earTagVerified: string;
  vaccinations: string[];
}

export interface Animal {
  _id: string;
  gn: string;
  animalID: string;
  dgr: string;
  farmer: string;
  image: string;
  birthDate: string;
  sex: string;
  breedingType: string;
  name: string;
  age: number;
  adg: string;
  fatherName: string;
  fatherBreed: string;
  coatColor: string;
  size: string;
  weight: number;
  evaluation: string;
  birthCondition: string;
  approvalStatus: boolean;
  paternalNucleus: string;
  paternalType: string;
  racialComposition: string;
  vaccination: string;
  damName: string;
  damDGR: string;
  damBreed: string;
  sireDGR: string;
  sireName: string;
  sireBreed: string;
  paternalGrandDamDGR: string;
  paternalGrandDamName: string;
  paternalGrandDamBreed: string;
  paternalGrandSireDGR: string;
  paternalGrandSireName: string;
  paternalGrandSireBreed: string;
  maternalGrandDamDGR: string;
  maternalGrandDamName: string;
  maternalGrandDamBreed: string;
  maternalGrandSireDGR: string;
  maternalGrandSireName: string;
  maternalGrandSireBreed: string;
  animalStatus: string;
  unit: string;
  farm: string;
  assignedSupervisor: string;
  cattleClass: string;
  phases: object[];
  recipientEvaluation: RecipientInput[];
  reproductiveProcess: ReproductiveProcessData[];
  teFivReceptorData: any;
  geneticMerits: any;
  slaughterInfo: string;
  diagnosis: string;
  phaseIStatus: boolean;
  phaseIIStatus: boolean;
  phaseIIIStatus: boolean;
  auction: string;
  status: string;
  inseminationProgram: string;
  numberOffspring: string;
  indexEfficiency: string;
  createdAt: Date;
  updatedAt: Date;
}

// export interface Animal {
//   _id: string;
//   farmer: string;
//   gn: string;
//   birthDate: string;
//   sex: string;
//   breedingType: string;
//   name: string;
//   age: string;
//   vaccination: string;
//   coatColor: string;
//   size: string;
//   paternalNucleus: string;
//   paternalType: string;
//   racialComposition: string;
//   weight: string;
//   phases: string[];
//   phaseIStatus: boolean;
//   phaseIIStatus: boolean;
//   phaseIIIStatus: boolean;
//   photo: string;
//   createdAt: string;
//   updatedAt: string;
//   __v: number;
//   animalStatus?: string;
//   unit?: string;
//   farm?: string;
//   image: string;
//   birthRegistryId?: string;
//   approvalStatus?: string;
//   assignedSupervisor?: string;
// }
//
// export interface Animal {
//   _id: string;
//   farmer: string;
//   gn: string;
//   birthDate: string;
//   sex: string;
//   breedingType: string;
//   name: string;
//   age: string;
//   vaccination: string;
//   coatColor: string;
//   size: string;
//   paternalNucleus: string;
//   paternalType: string;
//   racialComposition: string;
//   weight: string;
//   phases: string[];
//   phaseIStatus: boolean;
//   phaseIIStatus: boolean;
//   phaseIIIStatus: boolean;
//   photo: string;
//   createdAt: string;
//   updatedAt: string;
//   __v: number;
//   animalStatus?: string;
//   unit?: string;
//   farm?: string;
//   image: string;
//   birthRegistryId?: string;
//   approvalStatus?: string;
//   assignedSupervisor?: string;
// }
